(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moershu-brand"] && !Shopify.designMode) return;
  try {
    
 document.addEventListener('click',event=>{const category=event.target.closest('[data-category]');if(!category)return;const input=document.querySelector('[data-interest]');if(input){input.value=category.dataset.category;input.dispatchEvent(new Event('change',{bubbles:true}));}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reference-editorial"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('reference-editorial')) {
    customElements.define('reference-editorial', class extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        const tabs = [...this.querySelectorAll('[role="tab"]')];
        const select = (tab) => {
          tabs.forEach(t => {const active = t === tab; t.setAttribute('aria-selected', String(active)); t.tabIndex = active ? 0 : -1; this.querySelector('#'+t.getAttribute('aria-controls')).hidden = !active;});
        };
        tabs.forEach((tab,index) => {
          tab.addEventListener('click',()=>select(tab));
          tab.addEventListener('keydown',e=>{let i=index;if(e.key==='ArrowRight')i=(i+1)%tabs.length;else if(e.key==='ArrowLeft')i=(i-1+tabs.length)%tabs.length;else if(e.key==='Home')i=0;else if(e.key==='End')i=tabs.length-1;else return;e.preventDefault();select(tabs[i]);tabs[i].focus();});
        });
        const range = this.querySelector('input[type="range"]');
        range?.addEventListener('input',()=>range.parentElement.style.setProperty('--split',range.value+'%'));
        const slides = [...this.querySelectorAll('[data-slide]')];
        let current = 0;
        this.querySelectorAll('[data-direction]').forEach(button=>button.addEventListener('click',()=>{if(!slides.length)return;current=(current+Number(button.dataset.direction)+slides.length)%slides.length;slides.forEach((s,i)=>s.hidden=i!==current);this.querySelector('[data-counter]').textContent=`${current+1} / ${slides.length}`;}));
        this.addEventListener('shopify:block:select',event=>{const tab=event.target.closest('[role="tab"]');if(tab)select(tab);const slide=event.target.closest('[data-slide]');if(slide){current=slides.indexOf(slide);slides.forEach(s=>s.hidden=s!==slide);this.querySelector('[data-counter]').textContent=`${current+1} / ${slides.length}`;}});
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
